export default "__VITE_ASSET__hZ$YwNO6__"